import { useState } from "react";

import { Box, Button, Step, StepLabel, Stepper, Typography } from "@mui/material";

import UpdateBoothId from "../../IccGeneral/UpdateBoothId";
import CreateIccUser from "../../IccGeneral/CreateIccUser";
import CreateDatabase from "../../IccGeneral/CreateDatabase";
import CreateIccBranch from "../../IccGeneral/CreateIccBranch";
import CreateReportUser from "../../IccGeneral/CreateReportUser";
import CreateBillingUser from "../../Billing/CreateBillingUser/CreateBillingUser";

interface StepInfo {
    label: string;
    content: JSX.Element;
}

function OpenBillingSettings() {
    window.open("https://admindash.auto.works/billing/settings", "_blank", "noreferrer");
}

function WorkflowNewCustomer() {
    const [activeStep, setActiveStep] = useState<number>(0);

    const [createdDatabase, setCreatedDatabase] = useState<string | null>(null);
    const [createdBranchName, setCreatedBranchName] = useState<string | null>(null);

    const handleDatabaseCreated = (database: string) => {
        setCreatedDatabase(database);
        handleNext();
    }

    const handleBranchCreated = (branchName: string) => {
        setCreatedBranchName(branchName);
        handleNext();
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };


    const steps: StepInfo[] = [
        {
            label: "Create database",
            content: <CreateDatabase workflowNextStep={handleDatabaseCreated} />
        },
        {
            label: "Create branch",
            content: <CreateIccBranch
                workflowNextStep={handleBranchCreated}
                createdDatabase={createdDatabase} />
        },
        {
            label: "Create ICC user",
            content: <CreateIccUser
                workflowNextStep={handleNext}
                createdBranchName={createdBranchName} />
        },
        {
            label: "Create report user",
            content: <CreateReportUser
                workflowNextStep={handleNext}
                createdBranchName={createdBranchName} />
        },
        {
            label: "Create BoothId for report",
            content: <UpdateBoothId
                workflowNextStep={handleNext}
                createdDatabase={createdDatabase} />
        },
        {
            label: "Create billing user",
            content: <CreateBillingUser
                workflowNextStep={handleNext}
                createdBranchName={createdBranchName} />
        },
        {
            label: "Setup billing",
            content:
                <Button
                    variant="contained"
                    onClick={OpenBillingSettings}>
                    Open billing settings
                </Button>
        }
    ];

    return (
        <>
            <Stepper activeStep={activeStep}>
                {steps.map((label: StepInfo) => {
                    const stepProps: { completed?: boolean } = {};
                    return (
                        <Step key={label.label} {...stepProps}>
                            <StepLabel>{label.label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
            {
                activeStep === steps.length ? (
                    <>
                        <Typography sx={{ mt: 2, mb: 1 }}>
                            All steps completed - 👍
                        </Typography>
                    </>
                ) : (
                    <>
                        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, borderBottom: "1px solid gray" }}>
                            <Button
                                color="inherit"
                                disabled={activeStep === 0}
                                onClick={handleBack}
                                sx={{ mr: 1 }}
                            >
                                Back
                            </Button>
                            <Box sx={{ flex: '1 1 auto' }} />
                            <Button onClick={handleNext}>
                                {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                            </Button>
                        </Box>
                        <div style={{ margin: "10px" }}>
                            {steps[activeStep].content}
                        </div>
                    </>
                )
            }
        </>
    );
}

export default WorkflowNewCustomer;